import { AvvirEvent } from "type_aliases";

export const PROCORE_COORDINATION_ASSIGNEES_LOADED = 'procore_coordination_assignees_loaded';

export type ProcoreCoordinationAssigneesLoadedEvent = AvvirEvent<typeof PROCORE_COORDINATION_ASSIGNEES_LOADED, any>;

const procoreCoordinationAssigneesLoaded = (procoreCoordinationAssignees): ProcoreCoordinationAssigneesLoadedEvent => ({
  type: PROCORE_COORDINATION_ASSIGNEES_LOADED,
  payload: procoreCoordinationAssignees
});

export default procoreCoordinationAssigneesLoaded;